import { useEffect, useState } from "react";
import styled from "styled-components";
import Divider from "./components/ui/Divider";
import Header from "./components/layouts/Header";
import Footer from "./components/layouts/Footer";
import MapSection from "./components/sections/MapSection";
import ExpertGuidanceSection from "./components/sections/ExpertGuidanceSection";
import ContactDivider from "./components/ui/contacts/ContactDivider";
import Logo from "./components/layouts/Logo";

const App = () => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  return (
    <>
      <Header windowWidth={windowWidth} />
      <Divider isMobile={true} />
      <Container>
        {windowWidth <= 840 && <Logo isMobile={true} />}
        <MapSection isFullScreen={isFullScreen} handleFullScreen={handleFullScreen} windowWidth={windowWidth} />
        <ExpertGuidanceSection />
        <ContactDivider />
      </Container>
      <Divider />
      <Footer />
    </>
  );
};

const Container = styled.div`
  max-width: 1200px;
  padding: 0 20px;
  margin: 0 auto;
`;

export default App;
